// Module
var code = `<div class="js-broker-message-footer{{.okButtonVisible? '' : ' custom'}}">
    <terceraButton name="okButton" 
    text="{{.okButtonText}}" visible="{{.okButtonVisible}}"
    terceraButtonStyle="js-button-ok style-width-100" on-btnClick="onOKClick" />

    <terceraButton name="cancelButton"
        text="{{.cancelButtonText}}" visible="{{.cancelButtonVisible}}"
        terceraButtonStyle="js-button-gray25 style-width-100" on-btnClick="onCancelClick" />

    {{#each customButtons: i}}
        <terceraButton name="{{'customButton'+i}}"
            text="{{customButtons[i].Title}}" tooltip="{{customButtons[i].Tooltip}}"
            terceraButtonStyle="js-button-gray25 js-customBtn-width" on-btnClick="['onCustomButton'+i+'Click']" />
    {{/each}}
</div>`;
// Exports
export default code;